

interface IAuthConfig {
    accessTokenExpiryInMin: number
}

interface IAppConfig {
    appName: string,
    apiBaseUrl: string,
    appBaseUrl: string,
    authConfig: IAuthConfig,
}

export interface IAxiosDefaultDataObject {
    [key: string]: any
}

/**
 * App Configuration
 */

const ApplicationConfig: IAppConfig = {
    appName: "Miraj Inventory v3.9",
    // apiBaseUrl: "http://localhost:8000/api",
    // appBaseUrl: "http://localhost:3000",
    apiBaseUrl: "https://inventory.stormtimeout.com/api",
    appBaseUrl: "https://inventory.stormtimeout.com",

    authConfig: {
        accessTokenExpiryInMin: 5
    }
}

export default ApplicationConfig